export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5248.1c33a142.jpg";